export default __webpack_public_path__ + "static/home-feature-sample-3-450421a3f7a5a8dd4b5cb69defe1efa7.jpg";